// Window Resize Handler

(function($) {

    $(window).on('resize', function(){


    })

}(jQuery));